module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.wid == '' || _vm.wid == undefined) ? _c('div', {
    staticClass: "exhibition"
  }, [_c('ul', {
    staticClass: "layout-content categoryevery clearfix"
  }, _vm._l((_vm.categories), function(category, index) {
    return _c('li', {
      key: index
    }, [_c('el-select', {
      staticClass: "cselect",
      attrs: {
        "popper-class": "popperclass",
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          return _vm.handleSelectChange(category.type)
        }
      },
      model: {
        value: (category.value),
        callback: function($$v) {
          _vm.$set(category, "value", $$v)
        },
        expression: "category.value"
      }
    }, _vm._l((category.enums), function(item) {
      return _c('el-option', {
        key: item.id,
        staticClass: "celoption",
        attrs: {
          "label": item.name,
          "value": item.id
        }
      })
    }), 1)], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "layout-content"
  }, [_c('ul', {
    staticClass: "categorywork clearfix"
  }, _vm._l((_vm.works), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'noright': index % 4 == 3
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.url + '/assets/upload/' + item.cover,
        "alt": "未上传封面"
      },
      on: {
        "click": function($event) {
          return _vm.goDetail(item.id)
        }
      }
    }), _vm._v(" "), (item.top16 != '1000') ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": "16强作品",
        "placement": "top-start"
      }
    }, [_c('div', {
      staticClass: "status",
      style: ({
        background: 'url(' + _vm.url + '/assets/img/top16.png)'
      })
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "titlebox"
    }, [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.name,
        "placement": "top-start"
      }
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "categorycon"
    }, [_c('span', {
      staticClass: "categoryname"
    }, [_vm._v(_vm._s(_vm.groups[item.gid].name))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "categoryname"
    }, [_vm._v("编号：" + _vm._s(item.userid))]), _vm._v(" "), _c('span', {
      staticClass: "wrapline"
    }, [_vm._v("|")]), _vm._v(" "), _c('span', {
      staticClass: "area"
    }, [_vm._v("作者：" + _vm._s(item.username))])])])], 1)
  }), 0), _vm._v(" "), _c('el-pagination', {
    staticClass: "table-page",
    staticStyle: {
      "float": "right",
      "margin-top": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "current-page": parseInt(_vm.page),
      "page-sizes": [20, 30, 50],
      "page-size": parseInt(_vm.rows),
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": parseInt(_vm.total)
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]) : _c('div', {
    staticClass: "exhibition-detail"
  }, [_c('div', {
    staticClass: "titlebox"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.curWork.name))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-con layout-content"
  }, [_c('div', {
    ref: "leftbox",
    staticClass: "leftbox"
  }, [_c('div', {
    staticClass: "leftbox-con",
    class: _vm.topShow == true ? 'top' : ''
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("分组：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.groups[_vm.curWork.gid].name))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("作者姓名：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.curWork.username))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("学校：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.curWork.school))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("专业：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.curWork.major))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("指导老师：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.curWork.teacher))]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("编号：")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.curWork.userid))])])]), _vm._v(" "), _c('div', {
    ref: "rightbox",
    staticClass: "rightbox",
    attrs: {
      "oncontextmenu": "return false;",
      "ondragstart": "return false;",
      "oncopy": "return false;",
      "onselect": "return false"
    }
  }, [_c('div', {
    staticClass: "box-info"
  }, [_vm._v("作品说明：")]), _vm._v(" "), _c('div', {
    staticClass: "box-info",
    staticStyle: {
      "min-height": "50px"
    }
  }, [(_vm.curWork.note.length > 10) ? _c('div', {
    staticClass: "box-info",
    staticStyle: {
      "white-space": "pre-line"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.curWork.note) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-info"
  }, [_vm._v("作品图纸：")]), _vm._v(" "), _c('div', {
    staticClass: "box-info"
  }, _vm._l((_vm.curWork.imgs_url.split(':')[0].split(';')), function(imgUrl, index) {
    return _c('el-image', {
      key: index,
      attrs: {
        "max-width": "600px",
        "src": _vm.url + '/assets/upload/' + imgUrl,
        "alt": "图片加载失败",
        "preview-src-list": _vm.imgsList,
        "oncontextmenu": "return false;",
        "ondragstart": "return false;",
        "oncopy": "return false;",
        "onselect": "return false"
      }
    })
  }), 1), _vm._v(" "), (_vm.curWork.imgs_url.split(':').length > 1) ? _c('div', {
    staticClass: "box-info"
  }, [_vm._v("实体模型照片：")]) : _vm._e(), _vm._v(" "), (_vm.curWork.imgs_url.split(':').length > 1) ? _c('div', {
    staticClass: "box-info"
  }, _vm._l((_vm.curWork.imgs_url.split(':')[1].split(';')), function(imgUrl, index) {
    return _c('el-image', {
      key: index,
      attrs: {
        "max-width": "600px",
        "src": _vm.url + '/assets/upload/' + imgUrl,
        "alt": "图片加载失败",
        "preview-src-list": _vm.imgsList,
        "oncontextmenu": "return false;",
        "ondragstart": "return false;",
        "oncopy": "return false;",
        "onselect": "return false"
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.curWork.video != '') ? _c('div', {
    staticClass: "box-info"
  }, [_vm._v("作品视频：")]) : _vm._e(), _vm._v(" "), (_vm.curWork.video != '') ? _c('div', {
    staticClass: "box-info"
  }, [_c('video', {
    ref: "video1",
    attrs: {
      "width": "600px",
      "height": "375px",
      "controls": "",
      "oncontextmenu": "return false;",
      "ondragstart": "return false;",
      "oncopy": "return false;",
      "onselect": "return false"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.url + '/assets/upload/' + _vm.curWork.video,
      "type": "video/mp4"
    }
  }), _vm._v("\n                    当前浏览器不支持该视频格式\n                ")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bf800be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Exhibition.vue
// module id = 613
// module chunks = 1